module.exports = __webpack_public_path__ + "static/media/pdp_paperLinen.6a31d123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/papertypes/pdp_paperLinen.jpg
// module id = 1441
// module chunks = 71